import React from "react";
import BasePopup from "../Popup/index";
import bgPopupCongratu from "../../../../../assets/images/Mini-Game/bg-congratu.png";
import bgPopupCongratuHead from "../../../../../assets/images/Mini-Game/bg-congratu-head.png";
import styled from "styled-components";
import bgCoin from "../../../../../assets/images/Mini-Game/bg-coin-popup-cong.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import {
  setOpenPopupChangeCoinsSuccess,
  setOpenPopupFooter,
} from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import { useTranslation } from "react-i18next";

export default function PopupCongratula({ isOpen = true, className }) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const onCancel = () => {
    const element = document.getElementById("rell-container-minigame");
    if (element) {
      const offset = element?.getBoundingClientRect()?.top + window.scrollY;
      const scrollPosition = offset - 120;
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
    dispatch(
      setOpenPopupFooter({
        isShowPopup: false,
        step: null,
      })
    );

    dispatch(
      setOpenPopupChangeCoinsSuccess({
        isShowPopupChangeCoinsSuccess: false,
        totalCoins: 0,
      })
    );
  };

  return (
    <BasePopup
      BasePopup
      open={isOpen}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      <Container className='popup-cong-mini'>
        <img
          src={iconClosePopup}
          alt=''
          className='rule-mini-close congratula-btn-close scale-hover-item'
          onClick={onCancel}
        />
        <img src={bgPopupCongratuHead} alt='' className='bg-popup-cong-head' />
        <div className='popup-cong-mini-main'>
          <div className='content-main'>{t("mini_game.pop_up_received_coins.from_change_turns.prefix")} </div>
          <div className='content-coins'>
            {dataMiniGame?.popupChangeCoinsSuccess?.totalCoins}{" "}
            {dataMiniGame?.popupChangeCoinsSuccess?.totalCoins !== 1
              ? "Coins"
              : "Coin"}
          </div>
          <div className='content-main'>{t("mini_game.pop_up_received_coins.from_change_turns.suffix")}</div>
          <div className='img-coins'>
            <img src={bgCoin} alt='' />
          </div>
          <div className='button-action-cong' onClick={onCancel}>
            <img src={bgButton} alt='' />
            <div className='button-action-cong-content'>{t('mini_game.pop_up_received_coins.earn_more_pieces')}</div>
          </div>
        </div>
      </Container>
    </BasePopup>
  );
}

const Container = styled.div`
  position: relative;
  top: 80px;

  .bg-popup {
    object-fit: contain;
  }

  .congratula-btn-close {
    position: absolute;
    right: 0;
    top: -20%;
    z-index: 3;
    transform: translate(0, -50%);
  }

  .button-action-cong {
    position: relative;

    .button-action-cong-content {
      position: absolute;
      top: calc(50% - 4px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 18px;
      font-weight: 500;
    }
    img {
      width: 300px;
      height: 50px;
    }
  }

  .img-coins {
    text-align: center;
    margin: 12px 0;
  }

  .button-action-cong {
    text-align: center;
  }

  .bg-popup-cong-head {
    position: absolute;
    top: 0;
    transform: translate(0, -80%);
    height: auto;
    z-index: 2;
  }

  .popup-cong-mini-main {
    position: relative;
    background: url(${bgPopupCongratu}) no-repeat;
    background-size: 100% 100%;
    background-position: center;
    /* z-index: 2; */
    /* top: 315px; */
    width: 90%;
    margin: 0 auto;
    padding: 60px 0;
    /* left: 77px; */
  }

  .content-main,
  .content-coins {
    color: #64310b;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }

  .content-coins {
    font-size: 30px;
    font-weight: bold;
  }

  @media (min-width: 992px) {
    .button-action-cong {
      &:hover {
        cursor: pointer;
        scale: 1.03;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 576px) {
    .button-action-cong {
      img {
        width: 240px;
      }
      margin-left: -4px;
    }

    .popup-cong-mini-main {
      padding: 60px 0 40px;
    }

    .img-coins img {
      width: 175px;
    }
  }

  @media (max-width: 452px) {
    .bg-popup-cong-head {
      left: 50%;
      transform: translate(-50%, -80%);
      max-width: 110%;
    }
    .popup-cong-mini-main {
      width: 100%;
      left: 50%;
      padding: 40px 0;

      transform: translateX(-50%);
    }
  }

  @media (max-width: 412px) {
    .popup-cong-mini-main {
      padding: 40px 0;
    }
  }

  @media (max-width: 380px) {
    top: 40px;

    .content-main {
      font-size: 14px;
    }

    .content-coins {
      font-size: 24px;
    }

    .img-coins img {
      width: 160px;
    }

    .button-action-cong {
      img {
        width: 200px;
        height: 33px;
      }
      margin-left: -4px;
    }
  }
  .button-action-cong .button-action-cong-content {
    font-size: 14px;
  }
`;
